<template>
  <div class="flex text-center justify-center align-center p-1">
    Made With
    <svg
      class=" ml-2 mr-1"
      height="25"
      viewBox="0 0 529 611"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.45 372.395C11.8421 372.395 0 360.556 0 345.953C0 340.056 1.9305 334.611 5.194 330.213L15.3806 315.913L246.276 4.14532C248.108 1.63276 251.075 0 254.424 0C259.989 0 264.5 4.50994 264.5 10.0732V11.2065V372.395H26.45Z"
        fill="#3ECF8E"
      />
      <path
        d="M502.55 237.854C517.158 237.854 529 249.693 529 264.297C529 270.193 527.07 275.638 523.806 280.036L513.619 294.336L282.724 606.104C280.891 608.616 277.925 610.249 274.576 610.249C269.011 610.249 264.5 605.739 264.5 600.176V599.043V237.854H502.55Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M502.55 237.854C517.158 237.854 529 249.693 529 264.297C529 270.193 527.07 275.638 523.806 280.036L513.619 294.336L282.724 606.104C280.891 608.616 277.925 610.249 274.576 610.249C269.011 610.249 264.5 605.739 264.5 600.176V599.043V237.854H502.55Z"
        fill="url(#paint1_linear)"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="264.5"
          y1="314.891"
          x2="461.646"
          y2="391.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#249361" />
          <stop offset="1" stop-color="#3ECF8E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="178.852"
          y1="188.853"
          x2="277.265"
          y2="361.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
    +
    <svg viewBox="0 0 261.76 226.69" height="25" aria-label="Vue">
      <defs />
      <path
        fill="#41b883"
        d="M161.096398.001167l-30.2245777 52.3506912L100.6472426.001167H-.0049077l130.876728 226.687666L261.7485483.001167z"
      />
      <path
        fill="#34495e"
        d="M161.096398.001167l-30.2245777 52.3506912L100.6472426.001167H52.3457835L130.8718203 136.0111 209.3978571.001167z"
      />
    </svg>

    +
    <svg
      class="ml-1"
      fill="#3178c6"
      viewBox="0 0 27 26"
      height="25"
      aria-label="TypeScript"
    >
      <defs />
      <path
        d="M.98608 0H25.3094c.5446 0 .9861.436522.9861.975v24.05c0 .5385-.4415.975-.9861.975H.98608C.441483 26 0 25.5635 0 25.025V.975C0 .436522.441483 0 .98608 0zM14.6175 13.8324V11.7H5.25909v2.1324H8.6002v9.4946H11.26v-9.4946zm1.0604 9.2439c.4289.2162.9362.3784 1.5218.4865.5857.1081 1.2029.1622 1.8518.1622.6324 0 1.2331-.0595 1.8023-.1784.5691-.1189 1.0681-.3149 1.497-.5879s.7685-.6297 1.0187-1.0703.3753-.9852.3753-1.6339c0-.4703-.0715-.8824-.2145-1.2365-.1429-.3541-.3491-.669-.6186-.9447-.2694-.2757-.5925-.523-.9692-.7419s-.8014-.4257-1.2743-.6203c-.3465-.1406-.6572-.2771-.9321-.4095-.275-.1324-.5087-.2676-.7011-.4054-.1925-.1379-.3409-.2838-.4454-.4379-.1045-.154-.1567-.3284-.1567-.523 0-.1784.0467-.3392.1402-.4824.0935-.1433.2254-.2663.3959-.369s.3794-.1824.6269-.2392c.2474-.0567.5224-.0851.8248-.0851.22 0 .4523.0162.697.0486.2447.0325.4908.0825.7382.15.2475.0676.4881.1527.7218.2555.2337.1027.4495.2216.6475.3567V12.146c-.4015-.1514-.84-.2636-1.3157-.3365-.4756-.073-1.0214-.1095-1.6373-.1095-.6268 0-1.2207.0662-1.7816.1987-.5609.1324-1.0544.3392-1.4806.6203s-.763.6392-1.0104 1.0743c-.2475.4352-.3712.9555-.3712 1.5609 0 .7731.2268 1.4326.6805 1.9785.4537.546 1.1424 1.0082 2.0662 1.3866.363.146.7011.2892 1.0146.4298.3134.1405.5842.2865.8124.4378.2282.1514.4083.3162.5403.4946s.198.3811.198.6082c0 .1676-.0413.323-.1238.4662-.0825.1433-.2076.2676-.3753.373s-.3766.1879-.6268.2473c-.2502.0595-.5431.0892-.8785.0892-.5719 0-1.1383-.0986-1.6992-.2959-.5608-.1973-1.0805-.4933-1.5589-.8879z"
        clip-rule="evenodd"
      />
    </svg>
  </div>
  <span>
    by
    <a class="underline" href="https://twitter.com/chiubaca">chiubaca</a></span
  >
</template>

<script>
export default { name: "Footer" };
</script>
